<mat-icon class="spin"><mat-spinner color="accent" diameter="17">
</mat-spinner></mat-icon>